import React from 'react';

export const Header: React.FC = () => {
    return (
        <header className="tcmf-header">
            <div className="tcmf-header-container">
                <div className="flex items-center">
                    <img src="/logo192.png" alt="RISE Logo" className="h-6 mr-3" />
                    <a href="/" className="tcmf-logo">TCMF Generator</a>
                </div>
                <nav className="tcmf-nav">
                    <a href="https://tcmf-handbook.deplide.org/introduction.html" className="tcmf-nav-link" target="_blank" rel="noopener noreferrer">
                        Handbook
                    </a>
                </nav>
            </div>
        </header>
    );
};